const state = {
    create_tenant: false,
    create_client: false,
    create_resource: false,
    create_role: false,
    create_key: false,
    create_webhook: false,
    add_user: false,
    show_loading: false,
    ui_key: 1
};
const getters = {};
const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    }
};
const actions = {
    showDrawer(context, { drawer_name }) {
        context.commit('mutate', {
            property: `${drawer_name}`,
            with: true
        });
    },
    hideDrawer(context, { drawer_name }) {
        context.commit('mutate', {
            property: `${drawer_name}`,
            with: false
        });
    },
    showLoading(context) {
        context.commit('mutate', {
            property: 'show_loading',
            with: true
        });
    },
    changeUIKey(context) {
        context.commit('mutate', {
            property: 'ui_key',
            with: Math.random().toString(36)
        })
    },
    hideLoading(context) {
        context.commit('mutate', {
            property: 'show_loading',
            with: false
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}